import axios from 'axios'
import domain from '@/assets/js/domain/dev.domain.js'
const moment = require('moment')
// require('moment/locale/es')

export default {
  getTenders(from, limit) {
    return axios({
      url: domain.location,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        Authorization: 'Bearer ' + domain.apiKey,
      },
      data: {
        query: `
                  query {
                    Tenders(
                      page: { limit: ${limit}, offset: ${from} }
                      filters: [
                        {eq: {field: "procurementMethod", value: "open"}}
                      ]
                  ) {
                        values {
                          id
                          tenderID
                          procurementMethod
                          procurementMethodType
                          items {
                            classification {
                              id
                              scheme
                            }
                            
                          }
                          procuringEntity {
                            name
                            identifier {
                              id
                              scheme
                              legalName
                            }
                          }
                          enquiryPeriod {
                            startDate
                            endDate
                          }
                          tenderPeriod {
                            startDate
                            endDate
                          }
                          title
                          description
                          tenderPeriod {
                            startDate
                          }
                          status
                          value {
                            currency
                            amount
                          }
                        }
                      }
                    }
                `,
      },
    })
  },
  searchTenders(from, searchElement, searchPhrase) {
    let requestFilter = `filters: [
          {in: {field: "${searchElement}", values: "${searchPhrase}"}},
          {eq: {field: "procurementMethod", value: "open"}} 
        ],`
    let pageProperty = `page: { limit: 27, offset: ${from} }`

    let tendersQuerySlice = `
          Tenders(
          ${requestFilter}
          ${pageProperty}
        )`

    if (searchElement === 'date') {
      searchElement = 'tenderperiod.enddate'
      requestFilter = `
            filters: [
              { gte: { field: "tenderPeriod.endDate", value: "${moment(searchPhrase).toISOString()}" } }
              {eq: {field: "procurementMethod", value: "open"}}
              { lt: {field: "tenderPeriod.endDate", value: "${moment(searchPhrase)
                .add(1, 'days')
                .toISOString()}" } }
            ],`
      tendersQuerySlice = `Tenders(${requestFilter})`
    } else if (searchElement === 'identifier') {
      requestFilter = `
            filters: [
              {eq: {field: "tenderID", value: "${searchPhrase}"}}
              {eq: {field: "procurementMethod", value: "open"}}
            ]
            `
      tendersQuerySlice = `Tenders(${requestFilter})`
    } else if (searchElement === 'cpv') {
      requestFilter = `
            filters: [
              {
                eq: {
                  relatedField: { classification: { field: "id" } }
                  value: "${searchPhrase}"
                }
              }
              {eq: {field: "procurementMethod", value: "open"}}
            ] 
            `
      tendersQuerySlice = `Tenders(${requestFilter})`
    }

    return axios({
      url: domain.location,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        Authorization: 'Bearer ' + domain.apiKey,
      },
      data: {
        query: `
                  query {
                       ${tendersQuerySlice}
                       {
                        values {
                          id
                          tenderID
                          procurementMethod
                          procurementMethodType
                          items {
                            classification {
                              id
                              scheme
                            }

                          }
                          procuringEntity {
                            name
                            identifier {
                              id
                              scheme
                              legalName
                            }
                          }
                          enquiryPeriod {
                            startDate
                            endDate
                          }
                          tenderPeriod {
                            startDate
                            endDate
                          }
                          title
                          description
                          tenderPeriod {
                            startDate
                          }
                          status
                          value {
                            currency
                            amount
                          }
                        }
                      }
                    }
                `,
      },
    })
  },
  getTodayTenders(from, today, tomorrow, limit) {
    return axios({
      url: domain.location,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        Authorization: 'Bearer ' + domain.apiKey,
      },
      data: {
        query: `
                query {
                    Tenders(
                      filters: [
                        { lte: { field: "tenderID", value: "UA-${tomorrow}" }}
                        { gte: { field: "tenderID", value: "UA-${today}" }}
                      ]
                      page: { limit: ${limit}, offset: ${from} }
                    ) {
                      values {
                        id
                        tenderID
                        items {
                          classification {
                            id
                            scheme
                          }
                        }
                        procuringEntity {
                          name
                        }
                        enquiryPeriod {
                          startDate
                          endDate
                        }
                        tenderPeriod {
                          startDate
                          endDate
                        }
                        title
                        description
                        tenderPeriod {
                          startDate
                        }
                        status
                        value {
                          currency
                          amount
                        }
                      }
                    }
                  }
              `,
      },
    })
  },
  getFavoriteTenders(id) {
    return axios({
      url: domain.location,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        Authorization: 'Bearer ' + domain.apiKey,
      },
      data: {
        query: `
                  query {
                      Tenders(filters: [{in: {field: "id", values: ${id}}}]){
                        values {
                          id
                          tenderID
                          items {
                            classification {
                              id
                              scheme
                            }
                          }
                          procuringEntity {
                            name
                          }
                          enquiryPeriod {
                            startDate
                            endDate
                          }
                          tenderPeriod {
                            startDate
                            endDate
                          }
                          title
                          description
                          tenderPeriod {
                            startDate
                          }
                          status
                          value {
                            currency
                            amount
                          }
                        }
                      }
                    }
                `,
      },
    })
  },
  getTenderDetail(id) {
    const query = `query getTenderDetail($id: String!) {
        Tenders(filters: [{eq: {field: "id", value: $id}}]) {
          values {
           id,
           tenderID,
           status,
           title,
           value {
             amount
             currency
             valueAddedTaxIncluded
           },
           contracts {
               values {
                 status
                 period {
                   startDate
                   endDate
                 }
                 dateSigned
                 value {
                   amount
                   currency
                 }
                 suppliersIdentifiers {
                   values {
                     legalName
                   }
                 }
               }
           },
           description,
           submissionMethod,
           submissionMethodDetails,
           tenderPeriod {
             startDate
             endDate
           },
           procuringEntity {
             id
             name
             contactPoint {
               name
               email
               telephone
             }
             identifier {
               id
               scheme
               legalName
             }
           },
           tenderPeriod {
             startDate
             endDate
           },
           items {
               deliveryDate {
                 startDate
                 endDate
               }
               quantity
               relatedLot
               description
               unit {
                 id
                 name
               }
               classification {
                 id
                 scheme
               }
               deliveryAddress {
                 countryName
                 region
                 locality
                 streetAddress
                 postalCode
               }
           },
           lots {
             id
             title
             value {
               amount
               currency
             }
             status
             description
           }
           enquiryPeriod {
               startDate
               endDate
           }
           status,
           procurementMethod,
           procurementMethodType,
           awardCriteria,
           awardPeriod {
             startDate
             endDate
         }
          }
        }
      }`

    return axios({
      url: domain.location,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        Authorization: 'Bearer ' + domain.apiKey,
      },
      data: {
        query,
        variables: {
          id,
        },
      },
    })
  },
}
